const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
// see aws Cognito user password requirements: https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-policies.html
// see also https://stackoverflow.com/questions/58767980/aws-cognito-password-regex-specific-to-aws-cognito
const passwordRegex = /^(?!\s+)(?!.*\s+$)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ])[A-Za-z0-9$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]{8,256}$/;
const codeRegex = /^\d{6}$/;


export const validatePassword = (password?: string): boolean => {
  if (!password) {
    return false;
  }

  return passwordRegex.test(password);
}


export const validateEmail = (email: string): boolean => {
  return emailRegex.test(email);
}

export const validateResetCode = (code: string): boolean => {
  return codeRegex.test(code);
}